import axios from 'axios'

const workIp = '10.52.8.18'
const houseIp = '192.168.1.9'

const productionURL = "https://api.beuddy.com"


const devURL = `http://${houseIp}:3333`

const api = axios.create({
  baseURL: productionURL,
  //withCredentials: true
})

export default api